import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 20px;
`;

export const Description = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.greys.darker};
  font: ${({ theme }) => theme.fonts.textBigHeight24};
  text-align: left;
  white-space: pre-line;
`;

export const ErrorText = styled.div`
  color: ${(props) => props.theme?.colors?.infoRed};
  font: ${(props) => props.theme.fonts?.textSmallHeight14Weight600};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
`;

export const SelectorContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${({ theme }) => theme.colors.greys.light};
`;

export const ToggleContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
`;

export const ActualCompoContainer = styled.div`
  gap: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
`;
